var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75
    },
    width: 1687,
    height: 2065,
    xlinkHref: "C26E81F6.png",
    transform: "matrix(0.24 0 0 0.24 53.64 9.24)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,12.3c-109.9,0-199.3,89.4-199.3,199.3c0,79.9,31.7,117.8,66.9,165.8c34.9,47.7,120,124.3,129.4,124.3 c12.8,0,63.8-50,120.4-115.3c51.2-59.2,82-90.1,82-174.8C455.3,128,380,12.3,256,12.3z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,94.3c-2.4,0-4.8,1-6.5,2.7l-92.1,80.4c-1.2,0.9-1.9,2.2-1.9,3.7c0,2.5,2,4.6,4.6,4.6h22.8v73.1 c0,5,4.1,9.1,9.1,9.1h36.5c5,0,9.1-4.1,9.1-9.1v-54.8h36.5v54.8c0,5,4.1,9.1,9.1,9.1H320c5,0,9.1-4.1,9.1-9.1v-73.1h22.8 c2.5,0,4.6-2,4.6-4.6c0-1.5-0.7-2.8-1.9-3.7L262.5,97c0,0,0,0-0.1-0.1C260.8,95.2,258.4,94.3,256,94.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinHome);
export default __webpack_public_path__ + "static/media/pin_home.21060329607a39a65b146d58c6ee53d0.svg";
export { ForwardRef as ReactComponent };